<div class="page-header sticky-top">

  <!-- ENVIRONMENT NAME -->
  <div class="env-title text-center" *ngIf="environmentName">{{ environmentName }}</div>

  <div class="d-flex justify-content-between align-items-center px-3">

    <div class="cwk-pointer logo">
      <a id="cwk-logo" href="{{ urlRoot + '/' }}" tm-destination="/">
        <picture>
          <source srcset="https://{{ imagesServer }}/logo/logo-255x120.webp" type="image/webp" />
          <img class="img-fluid w-50" src="https://{{ imagesServer }}/logo/logo-255x120.png" alt="CodeRace.org Logo" width="100" height="60" />
        </picture>
      </a>
    </div>

    <!-- HEADER MENU -->
    <div class="header-menu w-100">
      <ng-content></ng-content>
    </div>
  </div>
</div>
